module.exports = __webpack_public_path__ + "images/emoji/bullettrain_front.976d1f57597ae2c6ea53.png";